import BaseQuizGame from "./BaseQuizGame.js";
import { renderFlagDuelError } from "../utils/FlagUtils.js";
import { getConfusionPool } from "../utils/FlagConfusionGroups.js";
import ArrayUtils from "../utils/ArrayUtils.js";

export default class FlagNerdTricky extends BaseQuizGame {
	constructor() {
		super('flagnerdtricky', '.flag-nerd-tricky', {
			passportStamp: "flag",
			gameNameKey: "home.flagNerd",
			modeLabelKey: "home.tricky",
			mode: "tricky",
			shareEmoji: "🧩",
			slug: "flag-nerd-tricky"
		});
		if (!this.page) return;

		this.init();
	}

	/** Distracteurs piochés en priorité parmi les pays visuellement/nominalement proches, complétés au besoin pour toujours proposer 4 choix. */
	getDistractorPool() {
		const confusables = getConfusionPool(this.rightAnswer.code);
		const pool = geoNerdApp.countries.filter(country => country.code === this.rightAnswer.code || confusables.has(country.code));

		if (pool.length >= 4) return pool;

		const extras = ArrayUtils.shuffle(geoNerdApp.countries.filter(country => !pool.some(p => p.code === country.code)));
		return pool.concat(extras.slice(0, 4 - pool.length));
	}

	renderErrorItem(error) {
		return renderFlagDuelError(error);
	}
}
